import { createConfig, deepMerge } from './index.js';

export const useMap = (props) => {
  const defaults = {
    createStore: () => new Map(),
    parseKey: (key) => key,
  };
  const config = createConfig(defaults, props);

  const store = config.createStore();

  const setItem = (key, value) => store.set(config.parseKey(key), value);
  const getItem = (key) => store.get(config.parseKey(key));
  const deleteItem = (key) => store.delete(config.parseKey(key));
  const clearAll = () => store.clear();
  const getSize = () => store.size || 0;
  const getEntries = () => Array.from(store.entries());
  const getKeys = () => Array.from(store.keys());
  const getValues = () => Array.from(store.values());

  const mergeItem = (key, value) => setItem(key, deepMerge(getItem(key), value));
  const setAll = (value) => {
    getKeys().forEach((key) => setItem(key, value));
  };
  const mergeAll = (value) => {
    getKeys().forEach((key) => mergeItem(key, value));
  };

  return { store, setItem, getItem, deleteItem, getSize, getEntries, getKeys, getValues, mergeItem, clearAll, setAll, mergeAll };
};
